import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject} from "rxjs";

@Injectable({providedIn: 'root'})
export class UserDataService {

    loggedIn:string;

    isLoggedIn: boolean;
    userData: any = [];
    userRole: string;
    redirectUrl: string;
    userEmail: string;
    dataLoaded: boolean;



    constructor(private http: HttpClient) {
        this.isLoggedIn = false;
    }

    // sign-up function
    signUpUser(user: object) {
        return this.http.post('agri/registerUser', user);
    }

    // login function
    login(email: string, password: string) {
        return this.http.post('agri/loginJob',
            {
                email,
                password
            }
        )
    }

    // Get main data for current user
    getMainData() {
        return this.http.get('agri/getCurrentUserInfo');
    }

    getUserById(userId){
        return this.http.get('agri/getUserById?userId='+ userId);
    }

    // Get all data for current user
    getData() {
        return this.http.get('agri/getCurrentUserDetailsJob');
    }

    changePassword(passwords: object) {
        return this.http.put('agri/changePassword', passwords)
    }

    sendResetUserPassword(email) {
        return this.http.get('agri/sendResetUserPassword?email=' + email);
    }

    resetNewPassword(newData: object) {
        return this.http.post('agri/resetNewPassword', newData);
    }


    // auto login function that checks if exists data for current user, not sure is the best method
    autoLogin() {

        this.loggedIn = localStorage.getItem("loggedIn");
        
        if(this.loggedIn === 'true'){

        this.getMainData()
            .subscribe(user => {
                this.userData = user;
                this.dataLoaded = true;
                this.isLoggedIn = true;

                if (this.userData.roles.includes('ROLE_JobBoardsClient')) {
                    // Save user role for Role Guard
                    this.userRole = 'client';
                } else if (this.userData.roles.includes('ROLE_JobBoardsCandidate')) {
                    // Save user role for Role Guard
                    this.userRole = 'candidate';
                }

                this.userEmail = this.userData.email;

            }, error => {
                this.dataLoaded = false;
                this.isLoggedIn = false;
            });
        }
    }

    getRole() {
        return this.userRole;
    }

    // Update main data for current user
    updateUserMainDetails(user: object) {
        return this.http.put('agri/updateUserJobBoard', user);
    }

    // Update account information for current user
    updateAccountDetails(user: object) {
        return this.http.put('agri/updateContInformation', user);
    }


    // Get current user company
    getCurrentUserCompany() {
        return this.http.get('agri/getCurrentUserCompany');
    }

    resendRegistrationCode(userEmail: string) {
        return this.http.get('agri/resendRegistrationCode?email=' + userEmail);
    }
}
